import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/*
  Knapper (Portal 2026): rolig navy primær, hvit sekundær med hairline, 40 px standardhøyde (44 px på mobil
  der sidene ber om det), 14 px tekst, tydelig fokusring og et lite trykk (scale 0.98) – aldri transition-all.
*/
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] text-sm font-medium transition-[background-color,color,border-color,box-shadow,opacity,transform] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-none hover:bg-[var(--hr-blue)]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-none hover:bg-destructive/90",
        outline:
          "border border-[var(--hr-border)] bg-white text-[var(--hr-text)] shadow-none hover:border-[rgba(31,33,48,0.28)] hover:bg-[var(--hr-surface-2)] hover:text-[var(--hr-heading)]",
        secondary:
          "bg-[var(--hr-inset)] text-[var(--hr-heading)] shadow-none hover:bg-[var(--hr-border)]",
        ghost: "text-[var(--hr-text)] hover:bg-[var(--hr-surface-2)] hover:text-[var(--hr-heading)]",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-[8px] px-3 text-sm",
        lg: "h-11 rounded-[12px] px-5 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
